/** Spotify playlists from a show's setlists: one private playlist per band, in the account behind the app's stored token. */
import { getJson, send } from "./request";

export interface Setlist {
  band_id: number;
  name: string;
  songs: string[];
}
export interface Playlist {
  band_id: number;
  name: string;
  url: string;
  matched: number;
  total: number;
  missing: string[];
}
export const fetchSetlists = async (showId: number) =>
  (await getJson<{ setlists: Setlist[] }>(`/api/shows/${showId}/setlists`, "Could not read the setlists")).setlists;
export const makePlaylist = (showId: number, bandId: number) =>
  send<Playlist>(`/api/shows/${showId}/playlist`, "POST", { band_id: bandId }, "Could not make the playlist");
